import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import React, { FC } from "react";

const enum fields {
    visibleForBreakpoints = "visibleForBreakpoints",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.visibleForBreakpoints]: string;
    };
}

const PromotionCode = getWidgetComponent("CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode");

const CartPromotionCode: FC<OwnProps> = ({fields}) => {
    return (
        <PromotionCode 
            visibleForBreakpoints={fields.visibleForBreakpoints} 
        />
    );
};

const widgetModule: WidgetModule = {
    component: CartPromotionCode,
    definition: {
        group: "Cart",
        allowedContexts: ["CartPage"],
        displayName: "Promotion Code Form",
        fieldDefinitions: [
            {
                name: fields.visibleForBreakpoints,
                displayName: "Visible for:",
                editorTemplate: "DropDownField",
                options: [
                    {
                        displayName: "Desktop",
                        value: "desktop",
                    },
                    {
                        displayName: "Mobile",
                        value: "mobile",
                    },
                    {
                        displayName: "Both",
                        value: "both",
                    },
                ],
                tooltip: "Determines whether the widget will be visible for mobile breakpoints, desktop breakpoints or both.",
                defaultValue: "both",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
